import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { site } from "@/data/siteContent";
import BrandLogo from "@/components/site/BrandLogo";

const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "why", label: "Why Us" },
  { id: "testimonials", label: "Testimonials" },
  { id: "gallery", label: "Gallery" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-500 ${
        scrolled
          ? "bg-[#050B14]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="container-luxe flex items-center justify-between h-20">
        <a
          href="#home"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <BrandLogo size={46} />
          <span className="flex flex-col leading-tight">
            <span className="font-display text-[15px] tracking-[0.22em] text-cream">
              JAY AMBE
            </span>
            <span className="font-display text-[10px] tracking-[0.4em] text-gold">
              JYOTISH
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.id}
              data-testid={`nav-link-${n.id}`}
              href={`#${n.id}`}
              className="text-[13px] tracking-[0.18em] uppercase text-cream/70 hover:text-gold transition-colors duration-300"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="#booking"
          data-testid="navbar-book-btn"
          className="hidden lg:inline-flex items-center px-6 py-2.5 rounded-full gold-border text-gold text-[12px] tracking-[0.22em] uppercase hover:bg-[#D4AF37] hover:text-[#050B14] transition-colors duration-500"
        >
          Book Consultation
        </a>

        <button
          data-testid="navbar-mobile-toggle"
          className="lg:hidden text-cream p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-white/5 bg-[#050B14]/95 backdrop-blur-xl"
          data-testid="navbar-mobile-menu"
        >
          <div className="container-luxe py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.id}
                data-testid={`nav-mobile-link-${n.id}`}
                href={`#${n.id}`}
                onClick={() => setOpen(false)}
                className="text-cream/85 text-sm tracking-[0.18em] uppercase py-2"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#booking"
              data-testid="navbar-mobile-book-btn"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center px-6 py-3 rounded-full gold-border text-gold text-[12px] tracking-[0.22em] uppercase"
            >
              Book Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
